module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box margin-top-10 card-renovacion text-center"
  }, [(_vm.idSolicitud) ? _c('div', [_c('span', [_vm._v("Hay una solicitud de renovación con estado ")]), _c('strong', [_vm._v(_vm._s(_vm.descripcionEstado))])]) : _c('div', [_c('span', [_vm._v("Pedir renovación de contrato para ")]), _c('span', {
    staticClass: "bold hint--top",
    attrs: {
      "aria-label": 'Empleado: ' + _vm.codigo
    }
  }, [_vm._v(_vm._s(_vm.nombre))]), _c('br'), _c('br'), _c('div', [_c('span', {
    staticClass: "little-text"
  }, [_vm._v("Ingresa los meses de renovación")]), _c('div', {
    staticClass: "control text-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mesesARenovar),
      expression: "mesesARenovar"
    }],
    staticClass: "input",
    attrs: {
      "type": "number",
      "disabled": _vm.disableMeses
    },
    domProps: {
      "value": (_vm.mesesARenovar)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mesesARenovar = $event.target.value
      }
    }
  })]), _c('span', {
    staticClass: "little-text text-center"
  }, [_vm._v("o activa el check de indeterminado")]), _c('br'), _c('label', {
    staticClass: "checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indeterminado),
      expression: "indeterminado"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.indeterminado) ? _vm._i(_vm.indeterminado, null) > -1 : (_vm.indeterminado)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.indeterminado,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.indeterminado = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.indeterminado = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.indeterminado = $$c
        }
      }
    }
  }), _vm._v(" Contrato indeterminado")])]), _c('br'), _c('div', {
    staticClass: "display-flex jc-center"
  }, [_c('div', {
    staticClass: "button",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.pedirRenovacion(false)
      }
    }
  }, [_vm._v("Pedir renovacion")]), _c('div', {
    staticClass: "button is-danger margin-left-5",
    class: {
      'is-loading': _vm.isSaving
    },
    on: {
      "click": function($event) {
        return _vm.pedirRenovacion(true)
      }
    }
  }, [_vm._v("No se renovará")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bce7ddde","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Component_Contratos_Pedir_Una_Renovacion.vue
// module id = 872
// module chunks = 0